<template>
  <section class="site-page section mt-5">
    <div class="container book-container text-center">
      <b-spinner
        v-if="loading"
        variant="boxx-red"
        label="Loading booking"
      ></b-spinner>
      <div v-else-if="error">
        <h1>{{ error }}</h1>
      </div>
      <div v-else>
        <b-row align-h="center">
          <b-col md="10" lg="8" xl="6">
            <h1 class="mb-0 p-3">
              <i class="fa fa-check"></i> Great, you're booked!
            </h1>
            <p class="pl-3 pr-3">
              You will receive a confirmation email shortly.
            </p>
            <br />
            <hr />
            <h3>
              <strong>
                {{ bookingSummary.serviceName }}
                <span
                  v-if="
                    !bookingSummary.resourceRandomlyAllocated &&
                      bookingSummary.resourceName
                  "
                >
                  with {{ bookingSummary.resourceName }}
                </span>
                at {{ bookingSummary.storeName }}
              </strong>
            </h3>
            <p class="lead">
              {{ bookingSummary.start | timestampToDate }}<br />
              {{ bookingSummary.start | timestampToTime }} —
              {{ bookingSummary.end | timestampToTime }}
            </p>
            <hr />
            <br />
            <add-to-calendar
              :title="calendarEventTitle"
              :location="bookingSummary.storeAddress"
              :start="new Date(bookingSummary.start)"
              :end="new Date(bookingSummary.end)"
              inline-template
            >
              <div>
                <google-calendar id="google-calendar">
                  <b-button variant="outline-boxx-red" type="button" block>
                    <i class="fa fa-google" /> Add to Google Calendar
                  </b-button>
                </google-calendar>
              </div>
            </add-to-calendar>
            <b-button
              class="mt-1"
              variant="boxx-red"
              type="button"
              block
              to="/book"
            >
              MAKE ANOTHER BOOKING
            </b-button>
          </b-col>
        </b-row>
      </div>
    </div>
  </section>
</template>
<script>
import { timestampToDate, timestampToTime } from '@/time';
import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      loading: true,
      error: null
    };
  },
  filters: {
    timestampToDate: timestampToDate,
    timestampToTime
  },
  methods: mapActions({
    fetchBookingSummary: 'bookings/fetchBookingSummary',
    clearBookingSummary: 'bookings/clearBookingSummary'
  }),
  computed: {
    ...mapGetters({
      bookingSummary: 'bookings/bookingSummary'
    }),
    calendarEventTitle() {
      if (!this.bookingSummary) return;

      const {
        storeName,
        serviceName,
        resourceRandomlyAllocated,
        resourceName
      } = this.bookingSummary;

      let title = '' + serviceName;

      if (!resourceRandomlyAllocated && resourceName) {
        title += ` with ${resourceName}`;
      }

      return `${title} at Boxx Barber Shop (${storeName})`;
    }
  },
  async mounted() {
    const { bid } = this.$route.query;

    if (!bid)
      return (this.error = "We're sorry, this booking could not be found.");

    try {
      await this.fetchBookingSummary(bid);
    } catch (e) {
      this.error = e.message;
    } finally {
      this.loading = false;
    }
  },
  beforeDestroy() {
    this.clearBookingSummary();
  }
};
</script>
<style></style>
